module.exports = __webpack_public_path__ + "static/media/image2.70fd4bc2.jpeg";